import ROUTES from "../../utils/Routes";
import { storeKeys } from "../../utils/Storage";
import { setFormSubmitting } from "../actions/ui";
import { LOG_USER_IN, LOG_USER_OUT, setLoggedInUserDetails } from "../actions/user";

const loginUserFlow = ({ log, api, alert }) => ({ dispatch }) => next => async action => {
    next(action);

    if (action.type === LOG_USER_IN) {
        try {
            const response = await api.auth.login(action.payload);
            const userData = {
                ...response.user,
                accessToken: response.tokens.access.token
            };
            localStorage.setItem(storeKeys.userdata, JSON.stringify(userData))
            dispatch(setLoggedInUserDetails(userData))
            alert.toast.success("Log In Successful");
        }
        catch (error) {
            alert.toast.error(error);
        }

        dispatch(setFormSubmitting(false))
    }

    if (action.type === LOG_USER_OUT) {
        localStorage.removeItem(storeKeys.userdata)
        dispatch(setLoggedInUserDetails(null))
        window.location.href = ROUTES.LOGIN;
    }
}


export default [
    loginUserFlow
]